import { ButtonSubmit } from "./buttonSubmit";
import { InputArquivo } from "./inputArquivo";
import { InputCPF } from "./inputCPF";
import { InputData } from "./inputData";
import { InputMultText } from "./inputMultText";
import { InputText } from "./inputText";

export function DynamicInput({ formik, id, label, type = "text", component, helpText, loading, required }) {
  const componentMap = {
    InputArquivo: <InputArquivo disabled={loading} id={id} label={label} type={type} formik={formik} helpText={helpText} required={required} />,
    InputText: <InputText disabled={loading} id={id} label={label} type={type} formik={formik} helpText={helpText} />,
    InputCPF: <InputCPF disabled={loading} id={id} label={label} type={type} formik={formik} helpText={helpText} />,
    InputMultText: <InputMultText disabled={loading} id={id} label={label} type={type} formik={formik} helpText={helpText} />,
    InputData: <InputData disabled={loading} id={id} label={label} type={type} formik={formik} helpText={helpText} />,
    ButtonSubmit: <ButtonSubmit loading={loading}>{label}</ButtonSubmit>,
  };

  return componentMap[component] || null;
}